import { useGlobalStoreSelector } from '@/stores/global.store';

// Callers are expected to render under AppLayout, which blocks on
// `currentCompany` before mounting its children. If you hit this throw, you
// are calling useCompanyID() outside that tree — gate the call behind
// `currentCompany` yourself, or use `state.currentCompany?.id` directly.
// Returning '' here used to silently produce `/companies//...` URLs that
// the backend then 404'd on, which masked real setup bugs.
export const useCompanyID = (): string => {
	const companyId = useGlobalStoreSelector((state) => state?.currentCompany?.id);

	return companyId ?? '';
};
